import { defineMessages } from 'react-intl';

const sortByMessages = defineMessages({
  topSellers: {
    id: 'sortBy.topSellers',
    defaultMessage: 'Top Sellers',
  },
  priceLowHigh: {
    id: 'sortBy.priceLowHigh',
    defaultMessage: 'Price: Low to High',
  },
  priceHighLow: {
    id: 'sortBy.priceHighLow',
    defaultMessage: 'Price: High to Low',
  },
  alphabetical: {
    id: 'sortBy.alphabetical',
    defaultMessage: 'Alphabetical',
  },
  topDiscount: {
    id: 'sortBy.topDiscount',
    defaultMessage: 'Top Discount',
  },
  latestDeals: {
    id: 'sortBy.latestDeals',
    defaultMessage: 'Latest Deals',
  },
  endingSoon: {
    id: 'sortBy.endingSoon',
    defaultMessage: 'Ending Soon',
  },
  mostWanted: {
    id: 'sortBy.mostWanted',
    defaultMessage: 'Most Wanted',
  },
  releaseDate: {
    id: 'sortBy.releaseDate',
    defaultMessage: 'Release: Newest',
  },
  releaseDateShort: {
    id: 'sortBy.releaseDateShort',
    defaultMessage: 'Release Date',
  },
  topRated: {
    id: 'sortBy.topRated',
    defaultMessage: 'Top Rated',
  },
  trending: {
    id: 'sortBy.trending',
    defaultMessage: 'Treding Deals',
  },
});

export default sortByMessages;
